import { ptlEnvs } from "../../../comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 *  Exchange Rate Management Service
 * !== 환율 관리 기능 서비스 ==!
 */

export const BASE = {
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/dw/bi`,
};

export const APIS = {
    getVeiwList: (data: any) => api.get(`${BASE.api}/list`, { params: comnUtils.toGetParams(data) }),
};

export const SF_DW_SRCH: TFormSchema = {
    id: "form_dwSrch",
    schema: {
        scrnList: { type: "select", label: "L_SCRN_NM", required: true },
    },
};

export const SF_EWC_SRCH: TFormSchema = {
    id: "form_ewcSrch",
    schema: {
        ewacType: { type: "select", label: "L_DIV", required: true, select: false},
    },
};
